import React from "react";
import { Col } from "react-bootstrap";
import MeetingPerson from "./MeetingPerson";
import "./MeetingPeopleList.css";

function MeetingPeopleList({ people, language }) {
  return (
    <Col className="meeting-people-list">
      {people.map((element) => (
        <MeetingPerson
          key={element._id}
          id={element._id}
          firstName={element.firstName}
          lastName={element.lastName}
          profileName={element.profileName}
          profileNameEnglish={element.profileNameEnglish}
          language={language}
        />
      ))}
    </Col>
  );
}

export default MeetingPeopleList;
